import React from "react";
import Table, { TableRow, TableCell } from "@amzn/meridian/table";
import Checkbox from "@amzn/meridian/checkbox";
import Button from "@amzn/meridian/button";
import Text from "@amzn/meridian/text";
import { AttachmentTableProps } from "./types";

export const AttachmentTable: React.FC<AttachmentTableProps> = ({
    attachments,
    selected,
    onChangeRow,
    fetchPresignedUrl,
}) => {
    return (
        <Table showDividers={true}>
            {attachments.map(attachment => (
                <TableRow key={attachment.canopyS3Key}>
                    <TableCell>
                        <Checkbox
                            checked={selected[attachment.canopyS3Key] || false}
                            onChange={onChangeRow(attachment.canopyS3Key)}
                        />
                    </TableCell>
                    <TableCell>
                        <Text>{attachment.fileName}</Text>
                        <Text color="secondary">{attachment.type}</Text>
                    </TableCell>
                    <TableCell alignmentHorizontal={"end"}>
                        <Button type={"secondary"} onClick={() => fetchPresignedUrl(attachment)}>
                            View
                        </Button>
                    </TableCell>
                </TableRow>
            ))}
        </Table>
    );
};
